//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    data: {
      type: Object,
      default: null,
    },
    value: {
      type: Object,
      default: null,
    },
    sectionKey: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      streetLine1: '',
      postcode: '',
      city: '',
      enterPressed: false,
    };
  },
  mounted() {
    this.inputValue = this.value ? this.value.value : '';
  },
  destroyed() {
    // this.saveValue();
  },
  methods: {
    focus() {
      // this.$refs.input.focus();
    },
    saveValue() {
      this.$emit('save', {
        focusNext: false,
        key: this.sectionKey,
        value: {
          textValue: [this.streetLine1, this.postcode, this.city].join(','),
          postcode: this.postcode,
          city: this.city,
          streetLine1: this.streetLine1,
        },
      });
      // this.enterPressed = false;
    },
  },
};
